import { handleGlobalErrors } from '../react-dev-overlay/internal/helpers/use-error-handler'

handleGlobalErrors()
